// ============================================================================
// BOQ — number formatting for the QS app
// ============================================================================
// Rates and amounts: rounded to 0 decimals (project's contract currency, e.g.
// INR or EUR). Quantities: integer, unless |value| < 10 in which case up to
// 2 decimals (small dimensions/counts keep their precision). One source of
// truth for the whole QS app.
// ============================================================================

export function formatMoney(value, currency) {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  if (isNaN(n)) return '';
  const code = currency || 'INR';
  // INR uses Indian lakh/crore grouping (₹1,00,000 / ₹1,00,00,000); other
  // currencies keep their default Western grouping.
  const locale = code === 'INR' ? 'en-IN' : undefined;
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(n);
  } catch {
    return n.toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }
}

// Quantity display rule (whole QS app): integer for |value| >= 10, otherwise
// up to 2 decimal places (preserves precision on small dimensions/counts).
export function formatQty(value) {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  if (isNaN(n)) return '';
  return n.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: Math.abs(n) < 10 ? 2 : 0,
  });
}

export function currencySymbol(currency) {
  const code = currency || 'INR';
  const locale = code === 'INR' ? 'en-IN' : undefined;
  try {
    const parts = new Intl.NumberFormat(locale, { style: 'currency', currency: code }).formatToParts(0);
    return parts.find((p) => p.type === 'currency')?.value || code;
  } catch {
    return code;
  }
}
